module.exports = __webpack_public_path__ + "img/usecase_enterprise_01.cee79612.jpg";